import React from 'react';
import { Guide } from '../../../types/guide';
import { Notes } from '../../../components/Notes';

interface NotesTabProps {
  guide: Guide;
}

export const NotesTab: React.FC<NotesTabProps> = ({ guide }) => {
  return (
    <div className="space-y-6">
      <Notes 
        subjectId={guide.id} 
        subjectType="guide" 
        subjectName={guide.name || 'Guide'}
      />
    </div>
  );
};